<template>
  <div>
    <Modal
      v-if="noModel == undefined"
      v-model="openForm"
      :title="title"
      footer-hide
      fullscreen
    >
      <div id="formTable">
        <div id="formTable">
          <div class="formTableItem">
            <p class="label">时间范围</p>
            <start-end ref="startEnd" timeModel="2,3,0"></start-end>
          </div>
          <div class="formTableItem">
            <Button @click="chaxun" type="primary" size="small" class="chaxun"
              >查询</Button
            >
          </div>
        </div>
      </div>

      <Table
        border
        :columns="columns"
        :data="tableData"
        no-data-text="<div class='table-no-data'></div>"
        :height="utils.setTableHeight(220)"
      >
      </Table>
      <div id="mypage">
        <div>
          <Page
            :current="1"
            :total="total"
            :page-size="searchItem.pageSize"
            :page-size-opts="[10, 50, 100]"
            show-total
            show-elevator
            show-sizer
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
          ></Page>
        </div>
      </div>
    </Modal>
    <template v-else>
      <report-top>
        <ly-search
          slot="search"
          v-model="searchItem.keyword"
          @search="search"
        ></ly-search>
      </report-top>
      <div id="formTable">
        <div id="formTable">
          <div class="formTableItem">
            <p class="label">时间范围</p>
            <start-end ref="startEnd" timeModel="2,3,0"></start-end>
          </div>
          <div class="formTableItem">
            <Button @click="chaxun" type="primary" size="small" class="chaxun"
              >查询</Button
            >
          </div>
        </div>
      </div>

      <Table
        border
        :columns="columns"
        :data="tableData"
        no-data-text="<div class='table-no-data'></div>"
        :height="utils.setTableHeight(220)"
        @on-expand="open"
      >
      </Table>
      <div id="mypage">
        <div>
          <Page
            :current="1"
            :total="total"
            :page-size="searchItem.pageSize"
            :page-size-opts="[10, 50, 100]"
            show-total
            show-elevator
            show-sizer
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
          ></Page>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import fields from "./fields";
export default {
  props: ["noModel"],
  data() {
    return {
      openForm: false,
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, data) => {
            console.log(data.row.content);
            return h("Table", {
              //局部注册组件不需要加引号
              props: {
                data: data.row.content,
                columns: this.columns1,
              },
            });
          },
        },
        {
          type: "index",
        },

        {
          title: "养护单号",
          key: "careNo",
        },
        {
          title: "单位名称",
          key: "groupName",
        },
        {
          title: "创建人账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmddhhmm"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageSize: 50,
        pageNumber: 1,
        keyword: "",
      },
      title: "",
      openForm123: false,
      serverUrl: "",
      columns1: [],
      tableData1: [],
    };
  },
  methods: {
    reach(v) {
      this.reset();
      this.openForm = true;
      this.title = v.name;
      this.searchItem.careId = v.docId;
      this.chaxun();
      var that = this;
      this.columns1 = JSON.parse(JSON.stringify(fields["dailyRecord"]));
      for (let i = 0; i < this.columns1.length; i++) {
        delete this.columns1[i].slot;
        if (this.columns1[i].key == "time") {
          this.columns1[i].render = function (h, data) {
            return h("div", that.utils.time(data.row.time, "yymmdd"));
          };
        }
      }
    },
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-rmm-server-dpm/care/execution/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          for (let i = 0; i < data.length; i++) {
            if (this.utils.isEmpty(data[i].content)) {
              data[i].content = [];
            } else {
              data[i].content = JSON.parse(data[i].content);
            }
          }
          this.tableData = data;
        }
      });
    },
    open(row) {
      //表格展开时候触发
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      this.reset();
      this.getList();
    },
    reset() {
      this.tableData = [];
    },
    xunchajilu(row) {
      this.$refs.nightRecordList.reach(row);
    },
    yanghujilu(row) {},
  },
  mounted() {
    //this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/yhgl/forms/dailyRecordList.vue